import { createContext, useContext, useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/settings").then(({ data }) => {
      setSettings(data || {});
      if (data?.favicon_url) document.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]').forEach((l) => { l.href = fileUrl(data.favicon_url); });
    }).finally(() => setLoaded(true));
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loaded }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);

export function getLeadSource() {
  try {
    const p = new URLSearchParams(window.location.search);
    return p.get("source") || p.get("utm_source") || null;
  } catch {
    return null;
  }
}
